import I18n from 'I18n';
import styled from 'styled-components';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { useTrackEvent } from 'automation-ui-usage-tracking/usageTrackingHooks';
import UIList from 'UIComponents/list/UIList';
import UIFlex from 'UIComponents/layout/UIFlex';
import UILink from 'UIComponents/link/UILink';
import UIIcon from 'UIComponents/icon/UIIcon';
import UITable from 'UIComponents/table/UITable';
import UIButton from 'UIComponents/button/UIButton';
import UIDropdown from 'UIComponents/dropdown/UIDropdown';
import UICopyButton from 'UIComponents/button/UICopyButton';
import Trackables from 'automation-ui-usage-tracking/Trackables';
import { getWebhookUrlForDefinition } from 'automation-ui-enrollment/utils/webhookUtils';
import useWorkflowTypePQLs from 'automation-ui-enrollment/components/workflowType/hooks/useWorkflowTypePQLs';
import { areWebhookTriggersAllowedForObjectType } from 'automation-ui-enrollment/hooks/useHasWebhookTriggersAccess';

// Needed to maintain the side border stylining overridden implicitly by the private UIPanel classes
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const UITableWithBorderOverride = styled(UITable).withConfig({
  displayName: "SameObjectWebhookEventsTable__UITableWithBorderOverride",
  componentId: "wn8enh-0"
})(["border-width:0 1px 1px !important;"]);
const SameObjectWebhookEventsTable = ({
  webhooks,
  handleWebhookSelect,
  setWebhookStagedForEdit,
  setWebhookStagedForDeletion
}) => {
  const trackEvent = useTrackEvent();
  const {
    isLocked,
    shouldSelectObjectType,
    CustomModal,
    onCloseCustomModal
  } = useWorkflowTypePQLs({
    objectTypeFilter: areWebhookTriggersAllowedForObjectType
  });
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [CustomModal && /*#__PURE__*/_jsx(CustomModal, {
      onClose: onCloseCustomModal
    }), /*#__PURE__*/_jsxs(UITableWithBorderOverride, {
      condensed: true,
      children: [/*#__PURE__*/_jsx("thead", {
        children: /*#__PURE__*/_jsxs("tr", {
          children: [/*#__PURE__*/_jsx("th", {
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "automation-ui-enrollment.webhookWizard.editTable.headers.eventName"
            })
          }), /*#__PURE__*/_jsx("th", {})]
        })
      }), /*#__PURE__*/_jsx("tbody", {
        children: webhooks.map((webhook, index) => /*#__PURE__*/_jsxs("tr", {
          children: [/*#__PURE__*/_jsx("td", {
            children: /*#__PURE__*/_jsxs(UILink, {
              onClick: () => {
                if (shouldSelectObjectType(webhook.objectTypeId)) {
                  handleWebhookSelect(webhook);
                }
              },
              children: [webhook.label, isLocked(webhook.objectTypeId) && /*#__PURE__*/_jsx(UIIcon, {
                name: "locked",
                className: "m-left-1"
              })]
            })
          }), /*#__PURE__*/_jsx("td", {
            children: /*#__PURE__*/_jsxs(UIFlex, {
              wrap: "nowrap",
              justify: "end",
              children: [/*#__PURE__*/_jsx(UICopyButton, {
                size: "xs",
                hint: I18n.text('automation-ui-enrollment.webhookWizard.editTable.actions.copyWebhookUrl.hint'),
                hintSuccess: I18n.text('automation-ui-enrollment.webhookWizard.editTable.actions.copyWebhookUrl.hintSuccess'),
                value: getWebhookUrlForDefinition(webhook),
                children: /*#__PURE__*/_jsx(UIIcon, {
                  name: "duplicate"
                })
              }), /*#__PURE__*/_jsx(UIDropdown, {
                buttonSize: "xs",
                buttonText: /*#__PURE__*/_jsx(FormattedMessage, {
                  message: "automation-ui-enrollment.webhookWizard.editTable.actions.actions"
                }),
                children: /*#__PURE__*/_jsxs(UIList, {
                  children: [/*#__PURE__*/_jsx(UIButton, {
                    use: "tertiary-light",
                    size: "xs",
                    onClick: () => {
                      trackEvent(Trackables.WEBHOOK_TRIGGER_MODIFIED, {
                        editType: 'EDIT',
                        objectTypeId: webhook.objectTypeId
                      });
                      setWebhookStagedForEdit(webhook);
                    },
                    children: /*#__PURE__*/_jsx(FormattedMessage, {
                      message: "automation-ui-enrollment.webhookWizard.editTable.actions.edit"
                    })
                  }), /*#__PURE__*/_jsx(UIButton, {
                    use: "tertiary-light",
                    size: "xs",
                    onClick: () => {
                      trackEvent(Trackables.WEBHOOK_TRIGGER_MODIFIED, {
                        editType: 'DELETE',
                        objectTypeId: webhook.objectTypeId
                      });
                      setWebhookStagedForDeletion(webhook);
                    },
                    children: /*#__PURE__*/_jsx(FormattedMessage, {
                      message: "automation-ui-enrollment.webhookWizard.editTable.actions.delete"
                    })
                  })]
                })
              })]
            })
          })]
        }, index))
      })]
    })]
  });
};
export default SameObjectWebhookEventsTable;